(function () {
  'use strict';

  var DATA_LAYER = 'dataLayer';
  var VIEW_ITEM_EVENT = 'view_item_stape';
  var ADD_TO_CART_EVENT = 'add_to_cart_stape';
  var STAPE_WAIT_MS = 900;
  var EXTERNAL_EVENT_TTL_MS = 3000;
  var DEBUG = /(?:^|[?&])aproche_tracking_debug=1(?:&|$)/.test(window.location.search);
  var observedDataLayerEntries = new WeakSet();
  var pendingExternalEvents = [];

  window[DATA_LAYER] = window[DATA_LAYER] || [];

  function toStringId(value) {
    return value === null || value === undefined ? undefined : String(value);
  }

  function centsToAmount(value) {
    var amount = Number(value);
    return Number.isFinite(amount) ? (amount / 100).toFixed(2) : undefined;
  }

  function majorToAmount(value) {
    var amount = Number(value);
    return Number.isFinite(amount) ? amount.toFixed(2) : undefined;
  }

  function getCurrency() {
    return window.Shopify?.currency?.active || 'USD';
  }

  function getPageType() {
    var path = window.location.pathname;

    if (path.includes('/products')) return 'product';
    if (path.includes('/collections')) return 'category';
    if (path.includes('/cart')) return 'basket';
    if (path === '/') return 'home';
    return 'other';
  }

  function getProductById(productId) {
    var id = toStringId(productId);
    var currentProduct = window.productShopStape;

    if (currentProduct && toStringId(currentProduct.id) === id) {
      return currentProduct;
    }

    var collectionProducts = window.collectionShopStape?.products || [];
    return collectionProducts.find(function (product) {
      return toStringId(product.id) === id;
    });
  }

  function getVariant(product, variantId) {
    var id = toStringId(variantId);
    return product?.variants?.find(function (variant) {
      return toStringId(variant.id) === id;
    });
  }

  function getSelectedVariant(product) {
    var query = window.location.search || window.location.href.split('?')[1]?.split('#')[0] || '';
    var variantMatch = query.match(/(?:^|&)variant=([^&]+)/);
    var urlVariantId;

    if (variantMatch) {
      try {
        urlVariantId = decodeURIComponent(variantMatch[1]);
      } catch (error) {
        urlVariantId = variantMatch[1];
      }
    }

    return getVariant(product, urlVariantId) || product?.variants?.find(function (variant) {
      return variant.available !== false;
    }) || product?.variants?.[0];
  }

  function getCatalogAmount(product, variant, field) {
    var value = variant?.[field];
    if (value === null || value === undefined) return undefined;

    // productShopStape is Shopify's product JSON (minor units/cents), while
    // collectionShopStape is rendered by Liquid in major currency units.
    return product === window.productShopStape ? centsToAmount(value) : majorToAmount(value);
  }

  function getImageUrl(product, variant) {
    return variant.image?.src ||
      variant.image?.url ||
      variant.featured_image?.src ||
      variant.featured_image?.url ||
      variant.featured_image ||
      product.featured_image?.src ||
      product.featured_image?.url ||
      product.featured_image ||
      undefined;
  }

  function buildItem(product, variant, quantity, price, compareAtPrice) {
    if (!product || !variant) return null;

    var item = {
      item_id: toStringId(product.id),
      item_sku: variant.sku || undefined,
      item_variant: toStringId(variant.id),
      item_name: product.title,
      variant_name: variant.title,
      item_category: product.category || product.type || undefined,
      item_brand: product.vendor || undefined,
      item_url: product.url || (product.handle ? '/products/' + product.handle : undefined),
      price: price,
      imageURL: getImageUrl(product, variant),
      quantity: quantity || 1,
    };

    if (compareAtPrice) item.compare_at_price = compareAtPrice;

    return item;
  }

  function itemKey(item) {
    return toStringId(item?.item_variant || item?.item_id);
  }

  function isMatchingEvent(entry, eventName, expectedItems) {
    if (entry?.aproche_tracking_source === 'theme_fallback') return false;
    if (!entry || entry.event !== eventName) return false;
    var actualItems = entry.ecommerce?.items || [];
    var compareQuantity = eventName !== ADD_TO_CART_EVENT;

    if (!expectedItems?.length) return true;
    if (actualItems.length !== expectedItems.length) return false;

    return expectedItems.every(function (expectedItem) {
      return actualItems.some(function (actualItem) {
        if (itemKey(actualItem) !== itemKey(expectedItem)) return false;
        // Shopify's cart/add response reports the line's cumulative quantity,
        // while Stape reports only the quantity added by the current action.
        // Variant identity is therefore the stable deduplication key here.
        if (!compareQuantity) return true;
        if (actualItem.quantity === undefined) return true;
        return Number(actualItem.quantity) === Number(expectedItem.quantity || 1);
      });
    });
  }

  function collectExternalEvents() {
    var now = Date.now();

    window[DATA_LAYER].forEach(function (entry) {
      if (!entry || typeof entry !== 'object' || observedDataLayerEntries.has(entry)) return;

      observedDataLayerEntries.add(entry);
      if (entry.aproche_tracking_source === 'theme_fallback') return;
      if (entry.event !== VIEW_ITEM_EVENT && entry.event !== ADD_TO_CART_EVENT) return;

      pendingExternalEvents.push({entry: entry, seenAt: now});
    });

    pendingExternalEvents = pendingExternalEvents.filter(function (record) {
      return now - record.seenAt <= EXTERNAL_EVENT_TTL_MS;
    });
  }

  function consumeMatchingExternalEvent(eventName, expectedItems) {
    collectExternalEvents();
    var index = pendingExternalEvents.findIndex(function (record) {
      return isMatchingEvent(record.entry, eventName, expectedItems);
    });

    if (index === -1) return false;
    pendingExternalEvents.splice(index, 1);
    return true;
  }

  function pushUnlessStapeAlreadyDid(eventName, expectedItems, payload) {
    var alreadyPushed = consumeMatchingExternalEvent(eventName, expectedItems);

    window.setTimeout(function () {
      if (!alreadyPushed) {
        alreadyPushed = consumeMatchingExternalEvent(eventName, expectedItems);
      }

      if (!alreadyPushed) {
        payload.aproche_tracking_source = 'theme_fallback';
        if (DEBUG && window.console?.info) {
          window.console.info('[Aproche tracking]', JSON.stringify(payload));
        }
        window[DATA_LAYER].push(payload);
      } else if (DEBUG && window.console?.info) {
        window.console.info('[Aproche tracking] existing Stape event', eventName);
      }
    }, STAPE_WAIT_MS);
  }

  function pushViewItem() {
    var product = window.productShopStape;
    var variant = getSelectedVariant(product);
    var item = buildItem(
      product,
      variant,
      1,
      getCatalogAmount(product, variant, 'price'),
      getCatalogAmount(product, variant, 'compare_at_price')
    );

    if (!item?.item_id || !item.item_variant || item.price === undefined) return;

    var amount = item.price;

    pushUnlessStapeAlreadyDid(VIEW_ITEM_EVENT, [item], {
      event: VIEW_ITEM_EVENT,
      ecomm_pagetype: getPageType(),
      actual_url: window.location.href,
      ecommerce: {
        value: amount,
        currency: getCurrency(),
        items: [item],
      },
    });
  }

  function normalizeAddedItems(response) {
    if (!response) return [];
    return Array.isArray(response.items) ? response.items : [response];
  }

  function positiveQuantity(value) {
    var quantity = Number(value);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : undefined;
  }

  function getRequestedQuantity(event, itemIndex, itemCount) {
    var button = event.detail?.button;
    var form = button?.form || button?.closest?.('form');

    if (!form?.querySelector) return 1;

    var fieldNames = itemCount > 1
      ? ['items[' + itemIndex + '][quantity]', 'quantity']
      : ['quantity', 'items[0][quantity]'];

    for (var index = 0; index < fieldNames.length; index += 1) {
      var field = form.querySelector('[name="' + fieldNames[index] + '"]');
      var quantity = positiveQuantity(field?.value);
      if (quantity !== undefined) return quantity;
    }

    return 1;
  }

  function pushAddToCart(event) {
    var response = event.detail?.response;
    if (DEBUG && window.console?.info) {
      window.console.info('[Aproche tracking] theme:product:add', JSON.stringify(response || null));
    }
    if (!response || Number(response.status) >= 400) return;

    var addedItems = normalizeAddedItems(response);
    if (!addedItems.length) return;

    var items = addedItems.map(function (addedItem, itemIndex) {
      var variantId = addedItem.variant_id || addedItem.id;
      if (!addedItem.product_id || !variantId) return null;

      var product = getProductById(addedItem.product_id);
      var catalogVariant = getVariant(product, variantId);
      var itemProduct = product || {
        id: addedItem.product_id,
        title: addedItem.product_title,
        vendor: addedItem.vendor,
        type: addedItem.product_type,
        url: addedItem.url,
      };
      var itemVariant = Object.assign({}, catalogVariant || {}, {
        id: variantId,
        title: addedItem.variant_title || catalogVariant?.title,
        sku: addedItem.sku || catalogVariant?.sku,
        featured_image: addedItem.featured_image || catalogVariant?.featured_image,
        image: addedItem.image || catalogVariant?.image,
      });
      var finalPrice = addedItem.final_price ?? addedItem.discounted_price ?? addedItem.price;
      var originalPrice = addedItem.original_price;
      var price = centsToAmount(finalPrice) || getCatalogAmount(product, catalogVariant, 'price');
      var compareAtPrice = Number(originalPrice) > Number(finalPrice)
        ? centsToAmount(originalPrice)
        : getCatalogAmount(product, catalogVariant, 'compare_at_price');
      var requestedQuantity = getRequestedQuantity(event, itemIndex, addedItems.length);
      var item = buildItem(itemProduct, itemVariant, requestedQuantity, price, compareAtPrice);

      if (!item?.item_id || !item.item_variant || item.price === undefined) return null;
      return item;
    }).filter(Boolean);

    if (!items.length) return;

    var value = items.reduce(function (total, item) {
      return total + Number(item.price || 0) * Number(item.quantity || 1);
    }, 0).toFixed(2);
    pushUnlessStapeAlreadyDid(ADD_TO_CART_EVENT, items, {
      event: ADD_TO_CART_EVENT,
      ecomm_pagetype: getPageType(),
      actual_url: window.location.href,
      ecommerce: {
        value: value,
        currency: getCurrency(),
        items: items,
      },
    });
  }

  collectExternalEvents();
  document.addEventListener('DOMContentLoaded', pushViewItem, {once: true});
  document.addEventListener('theme:product:add', pushAddToCart);
})();
